import React, { memo } from "react";
import { Link } from "react-router-dom";
import pcCareLogo from "../assests/images/pccarelogo.jpg";

const Footer = () => {
  return (
    <footer className="w-full bg-[#351F72] text-white font-sans">
      {/* 🔹 Social Section */}
      <div className="bg-[#F3802C]">
        <div className="max-w-8xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-center md:text-left text-white mb-0">
            Get connected with us on social networks
          </p>
          <div className="flex gap-4">
             {/* Social icons can go here if needed */}
          </div>
        </div>
      </div>

      {/* 🔹 Main Footer */}
      <div className="max-w-8xl mx-auto px-4 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Company */}
        <div>
          <img
            src={pcCareLogo}
            alt="PC Care Logo"
            className="h-12 w-12 mb-4 object-contain"
          />
          <p className="text-sm text-white/80 leading-relaxed mb-0">
            PC Care is a trusted second-hand laptop & computer store.
            We provide tested, reliable devices with warranty & support.
          </p>
          <div className="flex gap-3 mt-4">
            <a href="https://www.facebook.com/pccarejabalpur/" target="_blank" rel="noopener noreferrer" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-[#F3802C] transition no-underline">
              <i className="fab fa-facebook-f text-sm"></i>
            </a>
            <a href="https://www.instagram.com/pccare_jabalpur/" target="_blank" rel="noopener noreferrer" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-[#F3802C] transition no-underline">
              <i className="fab fa-instagram text-sm"></i>
            </a>
            <a href="https://www.youtube.com/@pccare_jabalpur" target="_blank" rel="noopener noreferrer" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-[#F3802C] transition no-underline">
              <i className="fab fa-youtube text-sm"></i>
            </a>
          </div>
        </div>

        {/* Pages */}
        <div>
          <h3 className="text-lg font-semibold text-[#FFC107] mb-4">
            Pages
          </h3>
          <ul className="list-none p-0 m-0 space-y-2 text-sm">
            <li>
              <Link to="/" className="text-white hover:text-[#F3802C] no-underline transition">
                Home
              </Link>
            </li>
            <li>
              <Link to="/products" className="text-white hover:text-[#F3802C] no-underline transition">
                Products
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-white hover:text-[#F3802C] no-underline transition">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-white hover:text-[#F3802C] no-underline transition">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Policies */}
        <div>
          <h3 className="text-lg font-semibold text-[#FFC107] mb-4">
            Policies
          </h3>
          <ul className="list-none p-0 m-0 space-y-2 text-sm">
            <li>
              <Link to="/shipping-policy" className="text-white hover:text-[#F3802C] no-underline transition">
                Shipping Policy
              </Link>
            </li>
            <li>
              <Link to="/return-policy" className="text-white hover:text-[#F3802C] no-underline transition">
                Return Policy
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" className="text-white hover:text-[#F3802C] no-underline transition">
                Refund & Cancellation Policy
              </Link>
            </li>
            <li>
              <Link to="/warranty-policy" className="text-white hover:text-[#F3802C] no-underline transition">
                Warranty Policy
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="text-white hover:text-[#F3802C] no-underline transition">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-conditions" className="text-white hover:text-[#F3802C] no-underline transition">
                Terms & Conditions
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-semibold text-[#FFC107] mb-4">
            Contact
          </h3>
          <ul className="list-none p-0 m-0 space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-3">
              <i className="fas fa-envelope text-[#F3802C]"></i>
              <a
                href="mailto:info@pccarecomputers.com"
                className="text-white hover:text-[#FFC107] no-underline transition"
              >
                info@pccarecomputers.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fas fa-phone text-[#F3802C]"></i>
              <a
                href="tel:+919238434606"
                className="text-white hover:text-[#FFC107] no-underline transition"
              >
                +91 9238434606
              </a>
            </li>
            <li className="flex items-start gap-3">
              <i className="fas fa-map-marker-alt text-[#F3802C] mt-1"></i>
              <a
                href="https://www.google.com/maps?q=23.168639,79.931806"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#FFC107] no-underline transition"
              >
                1035 1st floor opposite traffic station Malviya chowk jabalpur (MP) 482002
              </a>
            </li>
            <li className="flex items-start gap-3">
              <i className="fas fa-map-marker-alt text-[#F3802C] mt-1"></i>
              <span className="text-white">
                2nd Floor, 80-B, Kasturba Nagar, Near Chetak Bridge, Above Ayurvedic Clinic, Bhopal, Madhya Pradesh – 462023, India.
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* 🔹 Bottom Bar */}
      <div className="bg-[#2c185d] text-sm py-4 border-t border-white/10">
        <div className="max-w-8xl mx-auto px-4 flex flex-col items-center justify-between gap-2 sm:flex-row">
          <p className="mb-0 text-left">© {new Date().getFullYear()} PC Care. All Rights Reserved.</p>
          <div className="text-xs text-gray-100 text-center sm:text-right">
            Designed & Developed by{" "}
            <a
              href="https://yashsoftsolution.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F3802C] no-underline font-semibold"
            >
              Yashsoft Solution
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
